import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# Inject release and chunk metadata into sourcemaps
posthog-cli sourcemap inject --directory ./path/to/assets --project my-app --version 1.2.3
`}</code></pre>
    <p>{`The CLI will create or reuse the `}<a parentName="p" {...{
        "href": "/docs/error-tracking/releases"
      }}>{`release`}</a>{` for the detected or supplied project and version. The CLI will try to detect project and version information, but you can set them explicitly with `}<inlineCode parentName="p">{`--project`}</inlineCode>{` and `}<inlineCode parentName="p">{`--version`}</inlineCode>{`. We recommend setting the project, and letting the CLI detect the version, if your project is continuously deployed (the version will be the git commit hash at build time).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      